import {
  useIsMetadataFetchingForAllModules,
  useIsMetadataFetchingForModule,
} from "../../../store/modules/useSelectors";
import { useIsTemplateMetadataBulkFetching } from "../../../store/templateMetadata/hooks/useSelectors";
import { ModuleId } from "../../../globalTypes";

const useIsListOfTemplatesForModuleFetching = (moduleId: ModuleId) => {
  const isFetchingForModuleId = useIsMetadataFetchingForModule(moduleId);
  const isFetchingAllModules = useIsMetadataFetchingForAllModules();
  const isFetchingTemplates = useIsTemplateMetadataBulkFetching();

  return isFetchingForModuleId || isFetchingAllModules || isFetchingTemplates;
};

export default useIsListOfTemplatesForModuleFetching;
